import { useEffect } from "react";

type OrgOption = { id: string; name: string };

type AuthSlice = {
  realHasRole: (...r: string[]) => boolean;
  memberOrganizationIds: string[] | undefined;
};

/** Loads workspace org picker: full list for DB-confirmed platform admins, else member orgs only. */
export function useAdminPanelOrgOptions(sb: any, auth: AuthSlice, setOrgOptions: (orgs: OrgOption[]) => void) {
  useEffect(() => {
    (async () => {
      try {
        const canListAllOrgs = auth.realHasRole("platform_admin");
        const memberOrgIds = (auth.memberOrganizationIds ?? []).filter(Boolean);

        if (canListAllOrgs) {
          const { data: dbPlatformAdmin, error: platformGateError } = await sb.rpc("is_platform_role_at_least", { p_min_role: "platform_admin" });
          if (!platformGateError && dbPlatformAdmin === true) {
            const { data: rpcData, error: rpcError } = await sb.rpc("platform_list_orgs");
            if (!rpcError && Array.isArray(rpcData)) {
              setOrgOptions(
                (rpcData as { id: string; name: string }[])
                  .map((o) => ({ id: o.id, name: o.name }))
                  .sort((a, b) => a.name.localeCompare(b.name))
              );
              return;
            }
          }
        }

        if (memberOrgIds.length === 0) {
          setOrgOptions([]);
          return;
        }

        const { data, error } = await sb
          .from("organizations")
          .select("id, name")
          .in("id", memberOrgIds)
          .order("name", { ascending: true });
        if (!error && Array.isArray(data)) setOrgOptions(data as OrgOption[]);
        else setOrgOptions([]);
      } catch (e) {
        console.warn("[admin] load org options failed", e);
      }
    })();
  }, [auth, sb, setOrgOptions]);
}
